export default __webpack_public_path__ + "static/tiktokoffice-68fd8ea9ee8f2574e2a0351429fa88c8.png";